export default __webpack_public_path__ + "static/media/logo-colorful.11760f5c.svg";